import { Link } from "react-router-dom";
import useConfig from "@/hooks/useConfig";
import PageRoutes from "@/utils/constants";

/**
 * Shared v2 page footer: tenant logo/mark, legal links, and a copyright
 * line. Rendered at the bottom of every v2 page shell (SidebarLayout,
 * CenteredLayout, LegalDocumentPage, and any page with its own scroll shell)
 * so every v2 surface ends the same way.
 */
export function Footer() {
  const config = useConfig();
  const currentYear = new Date().getFullYear();
  const brandName = config?.subtitle || config?.mainName || config?.title || "";

  return (
    <footer className="w-full v2-section-gutter py-4 border-t border-slate-200">
      <div className="flex flex-col items-center text-center sm:flex-row sm:items-center sm:justify-between sm:text-left gap-4">
        <div className="flex items-center gap-3">
          {config?.logoUrl ? (
            <img
              src={config.logoUrl}
              alt={config?.name ?? "logo"}
              className="h-7 object-contain"
            />
          ) : (
            <span className="font-bold text-slate-900">{config?.mainName}</span>
          )}
        </div>

        <div className="flex items-center gap-5 text-sm font-medium text-slate-600">
          <Link
            to={PageRoutes.TermAndConditions}
            target="_blank"
            rel="noreferrer"
            className="hover:text-slate-900"
          >
            Terms & Conditions
          </Link>
          <Link
            to={PageRoutes.PrivacyPolicy}
            target="_blank"
            rel="noreferrer"
            className="hover:text-slate-900"
          >
            Privacy Policy
          </Link>
        </div>
      </div>

      {/* justify-center/sm:justify-start, not text-center/sm:text-left: Bootstrap's
          unlayered `.text-center { text-align: center !important }` beats Tailwind's
          layered text-align utilities at every width, so alignment is done with flex
          justification instead, which has no same-named Bootstrap class to lose to. */}
      <div className="mt-2 flex justify-center sm:justify-start">
        <span className="text-xs text-slate-400">
          &copy; {currentYear} {brandName}. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
